import { Services } from "../components/Services";
import { BOOKING_URL, SERVICES } from "../data/content";
import { Check, Clock, Sparkles } from "lucide-react";
import { FadeIn } from "../components/FadeIn";

export const ServicesPage = () => {
  return (
    <div className="py-12 sm:py-20 px-4 sm:px-8 lg:px-12">
      {/* Banner */}
      <div className="max-w-7xl mx-auto text-center mb-16">
        <FadeIn>
          <div className="text-xs uppercase tracking-[0.25em] text-amber-400 font-extrabold mb-3">
            Signature Spa Rituals
          </div>
          <h1 className="text-4xl sm:text-6xl font-serif font-black text-transparent bg-clip-text bg-gradient-to-r from-amber-300 via-yellow-500 to-amber-600 mb-6">
            Hammam Spa Services & Therapies
          </h1>
          <p className="text-white/70 max-w-2xl mx-auto text-sm sm:text-base leading-relaxed">
            Discover our curated male massage rituals and wellness therapies in New Delhi. 
            Crafted for muscle recovery, stress relief, and deep satisfaction.
          </p>
        </FadeIn>
      </div>

      {/* Main Services Grid */}
      <Services />

      {/* Highlights Table */}
      <div className="max-w-7xl mx-auto mt-20 pt-16 border-t border-white/10">
        <FadeIn>
          <h2 className="text-2xl sm:text-3xl font-serif text-amber-400 font-bold mb-8 text-center">
            What's Included in Every Service
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-[#0c0c0c] border border-amber-400/30 p-6 rounded-2xl">
              <div className="w-10 h-10 rounded-full bg-amber-400/10 text-amber-400 flex items-center justify-center mb-4">
                <Clock className="w-5 h-5" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Punctual & Dedicated Time</h3>
              <p className="text-xs text-white/60 leading-relaxed">
                Every minute is dedicated to your relaxation. Full service duration guaranteed.
              </p>
            </div>
            <div className="bg-[#0c0c0c] border border-amber-400/30 p-6 rounded-2xl">
              <div className="w-10 h-10 rounded-full bg-amber-400/10 text-amber-400 flex items-center justify-center mb-4">
                <Sparkles className="w-5 h-5" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Premium Oils & Cleanliness</h3>
              <p className="text-xs text-white/60 leading-relaxed">
                Warm aromatic oils, fresh sanitized linens, and fresh plush towels for every guest.
              </p>
            </div>
            <div className="bg-[#0c0c0c] border border-amber-400/30 p-6 rounded-2xl">
              <div className="w-10 h-10 rounded-full bg-amber-400/10 text-amber-400 flex items-center justify-center mb-4">
                <Check className="w-5 h-5" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Full Discretion & Courtesy</h3>
              <p className="text-xs text-white/60 leading-relaxed">
                Respectful, well-trained therapists providing judgment-free sanctuary space.
              </p>
            </div>
          </div>

          <div className="text-center mt-12">
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-gradient-to-r from-amber-300 via-yellow-500 to-amber-600 text-black font-extrabold px-10 py-4 rounded-full text-xs uppercase tracking-[0.2em] shadow-lg shadow-amber-950/40 hover:scale-105 transition-transform"
            >
              Book Your Desired Ritual
            </a>
          </div>
        </FadeIn>
      </div>
    </div>
  );
};
